var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.90602C4.13994 1.90602 1.40625 4.63971 1.40625 7.99977C1.40625 11.3598 4.13994 14.0935 7.5 14.0935C10.8601 14.0935 13.5937 11.3598 13.5937 7.99977C13.5937 4.63971 10.8601 1.90602 7.5 1.90602ZM10.6714 5.95749L6.73389 10.645C6.69069 10.6964 6.63695 10.738 6.57629 10.7669C6.51564 10.7957 6.44949 10.8112 6.38232 10.8123H6.37441C6.30871 10.8122 6.24375 10.7984 6.18374 10.7717C6.12373 10.7449 6.07001 10.7058 6.02607 10.657L4.33857 8.782C4.29572 8.73654 4.26238 8.68298 4.24052 8.62445C4.21866 8.56593 4.20872 8.50363 4.21128 8.44121C4.21384 8.37879 4.22886 8.31751 4.25544 8.26098C4.28202 8.20444 4.31964 8.15379 4.36608 8.112C4.41251 8.07021 4.46684 8.03812 4.52585 8.01763C4.58487 7.99713 4.64738 7.98864 4.70973 7.99265C4.77207 7.99666 4.83298 8.01309 4.88889 8.04098C4.94479 8.06887 4.99455 8.10765 5.03525 8.15504L6.36211 9.62926L9.95361 5.35456C10.0342 5.26142 10.1482 5.20372 10.2709 5.19394C10.3937 5.18415 10.5153 5.22307 10.6096 5.30228C10.7039 5.38149 10.7633 5.49462 10.7748 5.61723C10.7864 5.73983 10.7492 5.86206 10.6714 5.95749Z",
    fill: "#68D391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.8cbfde5ca3f442daecd70f000d787c58.svg";
export { ForwardRef as ReactComponent };